module.exports = __webpack_public_path__ + "assetsclientes/img/devias.ef193836.png";